import React, { useEffect, useState } from "react"
const SPRITE_URL = "/sprite/sprite.svg";

type Props = {
  name: string,
  styles: string,
  height?: string,
  width?: string,
}

let isSpriteLoaded = false;

export const Icon: React.FC<Props> = ({ name, styles, height = '24', width = '24'}) => {
  const [loaded, setLoaded] = useState(isSpriteLoaded);

  //Permet d'empêcher React d'aller chercher le sprite plusieurs fois alors qu'il a déjà été load
  useEffect(() => {
    if (!isSpriteLoaded) {
      const svgSprite = document.createElement('link');
      svgSprite.href = SPRITE_URL;
      svgSprite.rel = 'preload';
      svgSprite.as = 'image';
      document.head.appendChild(svgSprite);

      svgSprite.onload = () => {
        isSpriteLoaded = true;
        setLoaded(true);
      };
    }
  }, []);

  if (!loaded) {
    return null;
  }

  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={width}
      height={height}
      className={`${styles}`}
    >
      <use xlinkHref={`${SPRITE_URL}#${name}`} 
      />
    </svg>
  )
 }